// extracted by mini-css-extract-plugin
export default {"container":"container--zYqSC","card":"card--kRlFl","title":"title--ri92y","subtitle":"subtitle--U9P4K"};